import React, { FC, useContext } from 'react'
import PoolPanelTitle from '../PoolPanelTitle'
import { MemoPoolPanel } from '../PoolPanel'
import { EmptyLine } from '../catalog/EmptyLine'
import { Web3Context } from '../../hooks/web3'
import { getSupportedChain } from '../../config'
import { useReloader } from '../../hooks/use-reload'
import { HideBiggerThan, HideSmallerThan } from '../catalog/responsive/Hide'
import { PoolMobileView } from './PoolMobileView'
import { usePools } from '../../hooks/use-pools'
import { SwaapLargeLoader } from '../catalog/SwaapLoader'
import { InjectedWindow } from '../../utils/types'
import { PoolBannerClaimWhitelist } from '../waitlist/banner/PoolBannerClaimWhitelist'
import { PoolBannerWhitelistClaimed } from '../waitlist/banner/PoolBannerWhitelistClaimed'
import { useAccountState } from '../../hooks/useAccountState'
import { PoolBannerWaitlistNoBonus } from '../waitlist/banner/PoolBannerWaitlistNoBonus'
import { PoolBannerWaitlistClaimXpBonus } from '../waitlist/banner/PoolBannerWaitlistClaimXPBonus'
import { PoolBannerWaitlistNotJoined } from '../waitlist/banner/PoolBannerNotJoined'
import { desktopSize, tabletSize } from '../catalog/screen-sizes'
import { PoolBannerPlaceHolder } from '../waitlist/banner/PoolBannerPlaceHolder'

declare const window: InjectedWindow

export const PoolsPage: FC<{}> = () => {
  window.applicationContext.selectedPool = undefined
  const { appChainID } = useContext(Web3Context)
  const { loading } = usePools()

  const isSupported = appChainID === getSupportedChain().appId
  const isLoaded = !loading
  const { nonce, account } = useReloader()

  const { loaded, accountState } = useAccountState()

  const { whitelisted, onWaitlist, waitlistState } = accountState

  let showClaimWhitelistBanner =
    !!account &&
    loaded &&
    accountState.whitelisted &&
    accountState.whitelistState &&
    !accountState.whitelistState.claimed

  let showWhitelistedBanner =
    !!account &&
    loaded &&
    accountState.whitelisted &&
    accountState.whitelistState &&
    accountState.whitelistState.claimed

  let showWaitlistBannerClaimXpBonus =
    !!account &&
    loaded &&
    !whitelisted &&
    onWaitlist &&
    waitlistState.isExistingLP &&
    !!waitlistState.rank &&
    !waitlistState.receivedXpBonus

  let showWaitlistBannerNoBonus =
    !!account &&
    loaded &&
    !whitelisted &&
    onWaitlist &&
    !showWaitlistBannerClaimXpBonus

  let showWaitlistBannerNotJoined =
    (!!account &&
      loaded &&
      !showClaimWhitelistBanner &&
      !showWhitelistedBanner &&
      !showWaitlistBannerClaimXpBonus &&
      !showWaitlistBannerNoBonus) ||
    (!loading && account === undefined)

  let showPlaceholder = !showWaitlistBannerNotJoined && !loaded

  // Testing
  /*showClaimWhitelistBanner = false
  showWhitelistedBanner = false
  showWaitlistBannerClaimXpBonus = false
  showWaitlistBannerNoBonus = false
  showWaitlistBannerNotJoined = false

  showClaimWhitelistBanner = true*/

  return (
    <>
      <HideSmallerThan limit={tabletSize}>
        <EmptyLine block />
      </HideSmallerThan>
      <HideBiggerThan limit={tabletSize}>
        <EmptyLine />
      </HideBiggerThan>

      {<PoolBannerPlaceHolder />}

      <EmptyLine size={2} />

      <PoolPanelTitle key="all-title">Investment pools</PoolPanelTitle>
      <EmptyLine />

      <HideSmallerThan limit={desktopSize} className={'pool-desktop-view'}>
        <MemoPoolPanel enableUser={isSupported} connectNonce={nonce} />
      </HideSmallerThan>

      <HideBiggerThan limit={desktopSize} className={'pool-mobile-view'}>
        {isLoaded ? (
          <PoolMobileView enableUser={isSupported} />
        ) : (
          <SwaapLargeLoader />
        )}
      </HideBiggerThan>
    </>
  )
}
